import { siteStats } from "@/mocks/home";

export default function StatsStrip() {
  return (
    <section className="bg-primary-600">
      <div className="mx-auto grid max-w-[1200px] grid-cols-1 gap-6 px-4 py-12 sm:grid-cols-2 md:px-6 md:py-14 lg:grid-cols-4">
        {siteStats.map((stat, idx) => (
          <div key={stat.label} className="flex flex-col">
            <span className="font-heading text-3xl font-bold text-background-50 md:text-[34px]">
              {stat.value}
            </span>
            <span className="mt-2 text-sm font-medium text-background-100">{stat.label}</span>
            <span className={`mt-1 text-xs ${idx % 2 === 0 ? "text-accent-300" : "text-primary-200"}`}>
              {stat.note}
            </span>
          </div>
        ))}
      </div>
    </section>
  );
}